document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.collection-filters-and-grid-bison');
  if (!section) return;

  const filtersForm = section.querySelector('#FacetFiltersFormBison');
  const filtersSection = section.querySelector('#filters-section');
  const mobileTrigger = section.querySelector('#mobile-filter-trigger');
  const clearAllBtn = section.querySelector('#clearAllFilters');
  const priceRange = section.querySelector('.price-range');
  const priceLabels = section.querySelectorAll('.price-labels span');
  const mobileMq = window.matchMedia('(max-width: 991.98px)');
  let submitTimer;

  const isMobile = () => mobileMq.matches;

  const closeDrawer = () => {
    if (!filtersSection) return;
    filtersSection.classList.remove('open');
    mobileTrigger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  const openDrawer = () => {
    if (!filtersSection) return;
    filtersSection.classList.add('open');
    mobileTrigger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const scheduleSubmit = (delay = 0) => {
    if (!filtersForm) return;
    clearTimeout(submitTimer);
    submitTimer = window.setTimeout(() => {
      submitFiltersForm();
    }, delay);
  };

  const submitFiltersForm = () => {
    if (!filtersForm) return;

    const tagParam = filtersForm.dataset.tagFilterParam || section.dataset.tagFilterParam || 'filter.p.tag';
    const action = filtersForm.getAttribute('action') || window.location.pathname;
    const basePath = action.split('?')[0];
    const params = new URLSearchParams();

    const tagValues = [];
    filtersForm.querySelectorAll('.filter-tag-input').forEach((input) => {
      if (input.checked) tagValues.push(input.value);
    });

    const formData = new FormData(filtersForm);
    for (const [key, value] of formData.entries()) {
      if (!key || key === 'sort_by') continue;
      if (key === tagParam || key.includes('.tag')) continue;
      if (value === '' || value == null) continue;
      params.append(key, value);
    }

    const sortBy = filtersForm.querySelector('input[name="sort_by"]:checked');
    if (sortBy) params.set('sort_by', sortBy.value);

    if (tagValues.length) {
      tagValues.forEach((value) => {
        params.append(tagParam, value);
      });
    }

    const query = params.toString();
    window.location.href = query ? `${basePath}?${query}` : basePath;
  };

  const cleanBrokenFilterUrl = () => {
    const url = new URL(window.location.href);
    let changed = false;
    for (const [key, value] of [...url.searchParams.entries()]) {
      if (value === '') {
        url.searchParams.delete(key);
        changed = true;
      }
    }
    if (changed) {
      const next = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState(null, '', next);
    }
  };

  cleanBrokenFilterUrl();

  const onFacetChange = () => {
    if (isMobile()) return;
    scheduleSubmit();
  };

  if (mobileTrigger && filtersSection) {
    mobileTrigger.addEventListener('click', () => {
      if (filtersSection.classList.contains('open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  if (filtersSection) {
    filtersSection.addEventListener('click', (e) => {
      if (e.target.closest('.close-filters-btn')) {
        closeDrawer();
        return;
      }

      if (!e.target.closest('.filters-box')) {
        closeDrawer();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filtersSection?.classList.contains('open')) {
      closeDrawer();
    }
  });

  section.querySelectorAll('.filter-group').forEach((group) => {
    const header = group.querySelector('.filter-group-header');
    const arrow = group.querySelector('.icon-chevron');
    const content = group.querySelector('.filter-group-content');
    if (!header || !content) return;

    header.addEventListener('click', () => {
      content.classList.toggle('filter-group-content-hidden');
      if (content.classList.contains('filter-group-content-hidden')) {
        content.style.display = 'none';
      } else {
        content.style.display = '';
      }
      if (arrow) arrow.classList.toggle('rotate');
    });
  });

  const formatFacetMajorAmount = (amountMajor) => {
    const code = section.dataset.currencyCode;
    const n = Number(amountMajor);
    if (!Number.isFinite(n)) return String(amountMajor);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch {
      return String(amountMajor);
    }
  };

  if (priceRange && priceLabels.length === 2) {
    const paintRange = () => {
      const min = Number(priceRange.min || 0);
      const max = Number(priceRange.max || 100);
      const val = Number(priceRange.value || min);
      const percent = max > min ? ((val - min) * 100) / (max - min) : 100;
      priceRange.style.setProperty('--range-percent', `${percent}%`);
    };

    paintRange();

    priceRange.addEventListener('input', () => {
      priceLabels[1].textContent = formatFacetMajorAmount(priceRange.value);
      const maxInput = section.querySelector('.price-input-max');
      if (maxInput) maxInput.value = priceRange.value;
      paintRange();
    });
    priceRange.addEventListener('change', onFacetChange);
  }

  if (filtersForm) {
    filtersForm.addEventListener('submit', (e) => {
      e.preventDefault();
      submitFiltersForm();
    });

    const tagParam = filtersForm.dataset.tagFilterParam || section.dataset.tagFilterParam || 'filter.p.tag';
    const urlParams = new URLSearchParams(window.location.search);
    let activeTags = urlParams.getAll(tagParam).map((t) => decodeURIComponent(t.trim())).filter(Boolean);
    if (!activeTags.length) {
      const csvTags = urlParams.get(tagParam);
      if (csvTags) {
        activeTags = csvTags.split(',').map((t) => decodeURIComponent(t.trim())).filter(Boolean);
      }
    }
    if (activeTags.length) {
      filtersForm.querySelectorAll('.filter-tag-input').forEach((input) => {
        if (activeTags.includes(input.value)) input.checked = true;
      });
    }
  }

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const clearUrl = clearAllBtn.getAttribute('href');
      if (clearUrl) {
        window.location.href = clearUrl;
      }
    });
  }

  section.querySelectorAll(
    '.form-check-input[type="checkbox"], .form-check-input[type="radio"], .filter-tag-input'
  ).forEach((input) => {
    input.addEventListener('change', onFacetChange);
  });

  section.querySelectorAll('.filter-swatch-label input[type="checkbox"], .filter-swatch-label input[type="radio"]').forEach((input) => {
    input.addEventListener('change', onFacetChange);
  });

  section.querySelectorAll('.filter-pill-input').forEach((input) => {
    input.addEventListener('change', onFacetChange);
  });

  const minInput = section.querySelector('.price-input-min');
  const maxInput = section.querySelector('.price-input-max');
  if (minInput) minInput.addEventListener('change', onFacetChange);
  if (maxInput) maxInput.addEventListener('change', onFacetChange);
});
